// extracted by mini-css-extract-plugin
module.exports = {"container":"DisablePage_container__2FaTF"};